import { render, staticRenderFns } from "./MainScene.vue?vue&type=template&id=d45cb908&scoped=true&"
import script from "./MainScene.vue?vue&type=script&lang=js&"
export * from "./MainScene.vue?vue&type=script&lang=js&"
import style0 from "./MainScene.vue?vue&type=style&index=0&id=d45cb908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45cb908",
  null
  
)

export default component.exports